import Loader from './Loader';
import LoadingIcon from './LoadingIcon/LoadingIcon';

export default Loader;

export { LoadingIcon };
